




























import Vue from "vue";
import { upperFirst } from "lodash";
import TableHeader from "@/meta/TableHeader";
import EntityForm from "@/components/common/EntityForm.vue";
import RouteNames from "@/router/RouteNames";
import FormField from "@/meta/FormField";

export default Vue.extend({
  name: "SearchTable",
  components: { EntityForm },
  props: {
    entityName: {
      type: String,
      required: false,
      default: "entity",
    },
    entityNamePlural: {
      type: String,
      required: false,
      default: "entities",
    },
    detailRouteName: {
      type: String,
      required: false,
      default: "",
    },
    items: {
      type: Array as () => any[],
      required: true,
    },
    formFields: {
      type: Array as () => FormField[],
      required: true,
    },
    headers: { type: Array as () => TableHeader[], required: true },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => {
    return {
      dialog: false,
      search: "",
      form: {
        title: "",
        editItem: {} as any,
        index: -1,
      },
    };
  },
  computed: {
    upperName(): string {
      return upperFirst(this.entityName);
    },
    formattedColumns(): string[] {
      return this.headers.filter((h) => !!h.format).map((h) => h.value);
    },
  },
  methods: {
    detailPageLink(item: any): any {
      if (item && this.detailRouteName) {
        return {
          name: this.detailRouteName,
          params: { id: item._id },
        };
      } else {
        return { name: RouteNames.HOME };
      }
    },
    openDetailPage(item: any) {
      if (item && this.detailRouteName) {
        this.$router.push({
          name: this.detailRouteName,
          params: { id: item._id },
        });
      }
    },
    cancelDialog() {
      this.$set(this.form, "editItem", {});
      this.form.index = -1;
      this.dialog = false;
    },
    reloadItems() {
      this.cancelDialog();
      this.$emit("reloadItems");
    },
    findIndexOfItem(item: any): number {
      return this.items.findIndex((i) => i === item);
    },
    newItem() {
      this.$set(this.form, "editItem", {});
      this.form.index = -1;
      this.form.title = "New " + this.upperName;
      this.dialog = true;
    },
    async editItem(item: any) {
      const index = this.findIndexOfItem(item);
      this.$set(this.form, "editItem", item);
      this.form.index = index;
      this.form.title = "Edit " + this.upperName;
      this.dialog = true;
    },
    async saveItem(item: any) {
      this.$emit("saveItem", { item, index: this.form.index });
      this.dialog = false;
      this.$set(this.form, "editItem", {});
      this.form.index = -1;
    },
    async deleteItem(item: any) {
      if (
        confirm(
          `Do you really want to delete ${item.name}? This action CANNOT be undone!`
        )
      ) {
        const index = this.findIndexOfItem(item);
        this.$emit("deleteItem", { item, index });
      }
    },
  },
});
